"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("../Input"));
var _Field = _interopRequireDefault(require("../Field"));
var _excluded = ["helperText", "labelText", "name", "touched", "validationMessage", "ValidationComponent", "warningMessage"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextField = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var helperText = _ref.helperText,
    labelText = _ref.labelText,
    name = _ref.name,
    touched = _ref.touched,
    validationMessage = _ref.validationMessage,
    ValidationComponent = _ref.ValidationComponent,
    warningMessage = _ref.warningMessage,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var showError = touched && !!validationMessage;
  var showWarning = touched && !showError && !!warningMessage;
  var ariaErrorMessageId = "".concat(name, "-error");
  return /*#__PURE__*/_react["default"].createElement(_Field["default"], {
    helperText: helperText,
    labelText: labelText,
    name: name,
    touched: touched,
    validationMessage: validationMessage,
    ValidationComponent: ValidationComponent,
    warningMessage: warningMessage,
    ariaErrorMessageId: ariaErrorMessageId
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    name: name,
    id: name,
    error: showError,
    "aria-errormessage": ariaErrorMessageId,
    warning: showWarning,
    ref: ref
  }, inputProps)));
});
TextField.propTypes = {
  helperText: _propTypes["default"].node,
  labelText: _propTypes["default"].string,
  name: _propTypes["default"].string,
  touched: _propTypes["default"].bool,
  validationMessage: _propTypes["default"].string,
  ValidationComponent: _propTypes["default"].elementType,
  warningMessage: _propTypes["default"].string
};
TextField.displayName = 'TextField';
var _default = exports["default"] = TextField;